export default __webpack_public_path__ + "static/media/arrow-right-circle-yellow.e12e080f.svg";